import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import BackToPreviousPage from '../../../ui/BackToBtn';
import Inputs from '../../../components/InsuranceInputs';
import InsuranceSteps from '../../../components/InsuranceSteps';
import { 
  IInsurance, 
  InsuranceParameters, 
  SetInsuranceParameters,
  SetInsurance 
} from '../../../types';
import { OffersWrapper, PageTitle } from '../styles';

type Props = {
  insurance: IInsurance;
  insuranceParameters: InsuranceParameters;
  setInsuranceParameters: SetInsuranceParameters;
  setInsurance: SetInsurance; 
};

const PageHeader: React.FC<Props> = ({
  insurance,
  insuranceParameters,
  setInsuranceParameters, 
  setInsurance
}) => {
  const { t } = useTranslation();

  return (
    <OffersWrapper>
      <InsuranceSteps activeStep={2} />
      <Box sx={{position: 'relative'}}>
        <BackToPreviousPage url={'/'}/>        
        <PageTitle>{t('step_2')}</PageTitle>
      </Box>
      <Inputs
        insurance={insurance}
        insuranceParameters={insuranceParameters}
        setInsuranceParameters={setInsuranceParameters}
        setInsurance={setInsurance}
        withoutButton       
      />
    </OffersWrapper>
  );
};

export default PageHeader;
